import{a as t}from"./chunk-RAAYCPUM.js";function T(...e){return t(s,e)}function s(e,n,o){let{[n]:p,[o]:r}=e;return{...e,[n]:r,[o]:p}}export{T as a};
